module.exports = __webpack_public_path__ + "img/icon_delete_comment.0a289ce.svg";